import { OrderNoteOptionDto } from './orderNoteOption.dto';
import { BaseDto } from './base.dto';

export class MerchantOrderNoteOptionDto extends BaseDto {
  merchantId: number;
  orderNoteOptionId: number;
  orderNotes?: OrderNoteOptionDto[];
} 